<template>
  <section>
    <b-button
      class="mb-2"
      variant="primary"
      size="sm"
      :to="`/${$route.params.accountId}/nativeadtemplate/edit`"
    >
      <GjIcon
        class="mr-50"
        name="Plus"
      />
      {{ $tk('ClientPortal.NativeAdTemplate.CreateTemplate') }}
    </b-button>
    <b-card
      no-body
      class="client-table"
    >
      <div class="client-table__data">
        <b-table
          :items="wrapper"
          :fields="fields"
          show-empty
          :empty-text="$tk('ClientPortal.Templates.NoTemplatesHaveBeenCreatedYet')"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template #empty="scope">
            <div class="text-center p-3 client-table__empty">
              <div class="empty__client-table">
                <GjIcon
                  size="64px"
                  name="Webpage"
                />
                <div class="mb-50">
                  {{ scope.emptyText }}
                </div>
                <b-link :to="`/${$route.params.accountId}/nativeadtemplate/edit`">
                  <GjIcon
                    size="14"
                    name="Plus"
                  />
                  <span class="create-text">{{ $tk('ClientPortal.NativeAdTemplate.CreateTemplate') }}</span>
                </b-link>
              </div>
            </div>
          </template>
          <template #cell(name)="data">
            <div class="d-flex align-items-center justify-content-between">
              <span>
                {{ data.item.name }}
              </span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
                button-class="p-0"
                right
              >
                <template v-slot:button-content>
                  <GjIcon name="Moreoptions_fill" />
                </template>
                <b-dropdown-item :to="`/${$route.params.accountId}/nativeadtemplate/edit?templateId=${data.item.id}`">
                  <GjIcon
                    class="mr-50"
                    name="Edit"
                  />
                  {{ $tk('ClientPortal.Property.Edit') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
      </div>
      <b-card-footer
        v-if="wrapper.length > 0"
        class="client-table__footer d-flex"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
          class="my-0 mr-1"
          hide-goto-end-buttons
        >
          <template #prev-text>
            <GjIcon
              class="mr-25"
              name="ArrowLeft"
            />
          </template>
          <template #next-text>
            <GjIcon
              class="ml-25"
              name="ArrowRight"
            />
          </template>
        </b-pagination>
        <span>
          {{ $tk('ClientPortal.Pagination.Viewing') }} {{ templatesFromCount }} {{ $tk('ClientPortal.Pagination.To') }} {{ templatesToCount }} {{ $tk('ClientPortal.Pagination.Of') }} {{ totalRows }} {{ $tk('ClientPortal.Pagination.Items') }}
        </span>
      </b-card-footer>
    </b-card>
  </section>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import NativeAdTemplatesService from '@/api/client/nativeAdTemplates.service'
import notification from '@/mixins/toastification'

export default {
  components: {
    GjIcon,
  },
  mixins: [notification],
  data() {
    return {

      wrapper: [],
      loading: false,
      totalRows: 10,
      currentPage: 1,
      perPage: 10,
    }
  },
  computed: {
    templatesFromCount() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    templatesToCount() {
      const toCount = this.currentPage + this.perPage - 1
      return Math.min(toCount, this.totalRows)
    },
    fields() {
      return [
        {
          key: 'name',
          label: this.$tk('ClientPortal.Property.Name'),
          sortable: true,
        },
      ]
    },
  },
  async mounted() {
    this.loading = true
    try {
      const response = await NativeAdTemplatesService.getNativeAdTemplates(this.$route.params.accountId)
      this.wrapper = response
    } catch (error) {
      this.error(error.message)
    } finally {
      this.loading = false
    }
    this.totalRows = this.wrapper.length
  },
}
</script>
